import React, { useEffect, useState } from 'react';
import { Container, Breadcrumbs, Button, Grid, Box, Typography, } from "@material-ui/core";
import { useStyles } from "./recentDesignStyle";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Link, useRouteMatch } from 'react-router-dom';
import CreateNewDLPModal from "./CreateNewDlpModal";
// import NewDLPPreview from "./NewDLPPreview";
import { useCustomLPApi } from '../service';
import { getUserCredential } from 'lib/cookies';
import TemplateLoader from './TemplatesLoader';
import { API } from 'api-setup/api-helper';
import { shallowEqual, useSelector } from 'react-redux';
import { commonSelector, basicInfoSelector, eventDataSelector } from 'redux/custom-selector';
import LearnMoreLink from 'learnMoreLinks';

const ChooseNewDLPTemplate = () => {
  const [open, setOpen] = useState(false);
  // const [preview, setPreview] = useState(false);
  const classes = useStyles();
  const match = useRouteMatch();
  const [customLPData, Action] = useCustomLPApi();
  const cookiesData = getUserCredential();
  const reduxData = useSelector(commonSelector, shallowEqual);
  const basicInfo = useSelector(basicInfoSelector, shallowEqual);
  const eventData = useSelector(eventDataSelector, shallowEqual);
  const [headers] = API.generateHeader(reduxData, null, null);
  const { dlpTemplates } = customLPData;
  const reorderedTemplates = Array.isArray(dlpTemplates)
    ? dlpTemplates.sort((a, b) => {
      return a.template === 'default' ? -1 : b.template === 'default' ? 1 : 0;
    })
    : [];
  const [currentSelectedTemplate, setCurrentSelectedTemplate] = useState(null);
  const isNewDLPEnabled = eventData?.EventData?.isNewDLPEnabled;

  useEffect(() => {
    // Action.getDefaultTemplates('/dlp/default');
    Action.getDlpTemplates('/dlp/templates');
  }, [])

  const handleTemplate = (templateData) => {
    setCurrentSelectedTemplate(templateData);
    setOpen(true);
  }
  const handlePreview = (item, type, templateName) => {
    setCurrentSelectedTemplate(item);
    const url = `${process.env.REACT_APP_BUILDER_URL}/validate-token?token=${cookiesData.authToken}&eventId=${headers.eventId}&organiserId=${headers.organiserId}${basicInfo?.selectedLanguages?.[0] ? `&language=${basicInfo?.selectedLanguages?.[0]}` : ''}${headers.teamMemberId ? `&teamMemberId=${headers.teamMemberId}` : ''}${type === 'preview' ? `&route=preview/${templateName}` : ''}`;
    window.open(url, '_blank');
    // setPreview(true);
  }

  return (
    <>
      {customLPData.loadingState.initLoad ? (
        <Container maxWidth="lg">
          <TemplateLoader />
        </Container>
      ) : (
        <Container maxWidth="lg">
          <Box component="header" mb={2}>
            <Breadcrumbs
              className={classes.breadCrumbsBlock}
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb">
              <Link
                to={`/event/${match.params.eventId}/${match.params.organiserId}/registration/landing-page`}
                color="inherit">
                Event Landing page
              </Link>
              <Typography color="textSecondary" variant="body2">
                Choose Template
              </Typography>
            </Breadcrumbs>
          </Box>
          <Box mb={3} className={classes.newDLPBlock}>
            <Typography variant="h4" component="h4">
              Canvas+ Templates
            </Typography>
            <Typography component="p" variant="body2" color="textSecondary" className="desc">
              Select a template to get started with your new landing page. All templates are fully
              customizable using our new Canvas Studio editor.
              <Box
                onClick={() =>
                  window.open(
                    isNewDLPEnabled ? LearnMoreLink.newCustomDLP : LearnMoreLink.eventLandingPage,
                    '_blank'
                  )
                }
                component="a"
                variant="body2"
                ml={0.3}
                className="text-underline  cursor-pointer">
                Learn More
              </Box>
            </Typography>
            <Grid container spacing={2}>
              {reorderedTemplates &&
                reorderedTemplates.length > 0 &&
                reorderedTemplates.map((item, index) => {
                  return (
                    <Grid item xs={12} lg={3} key={index}>
                      <Box className={classes.template}>
                        <img
                          src={`${process.env.REACT_APP_CDN_PATH}/newlp/images/${item.image}`}
                          alt={`no-${item.template}`}
                        />
                        <Box className="action">
                          <Button
                            onClick={() => handleTemplate(item)}
                            variant="contained"
                            color="primary">
                            Use this template
                          </Button>
                          <Button
                            onClick={() => handlePreview(item, 'preview', item.template)}
                            variant="outlined"
                            color="primary">
                            Preview
                          </Button>
                        </Box>
                      </Box>
                      <Typography variant="h6" component="h5" className={classes.tpName}>
                        {item.template === 'default' ? 'Blank' : item.template}
                      </Typography>
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
          <CreateNewDLPModal
            open={open}
            onClose={() => setOpen(false)}
            currentTemplate={currentSelectedTemplate}
          />
          {/* {preview && <NewDLPPreview dlpTemplates={currentSelectedTemplate} onClose={() => setPreview(false)} />} */}
        </Container>
      )}
    </>
  );

}

export default ChooseNewDLPTemplate;